export const cardLimitInfo = {
    enabled: true,
    _description:
        'Displays collapsible limit information table bellow the card header - supported by AT only (requires sbDeckelungsLimits field)',
};
